
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });
  
   // WISHLIST
 Flits(document).on("Flits:Loaded",function(event){
    if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
      Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
    }
  });
 Flits(document).on('Flits:wishlistButton:Loaded', function(event){
   if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
     let collectionBtn = Flits('.flits-wishlist-colection');
     parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
       Flits(collectionBtn).show(),
       Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
   }
 });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });

  


//   var sub_url = Flits('.th_subscription_cp_link').attr('href');
//     var sub_url = 'https:///archdekor.com/tools/recurring/login';
// //   console.log(sub_url)
//   Flits(document).on('Flits:myProfile:Loaded', function(event){
//     Flits(".flits-sub-link").find('a').attr("href",sub_url);
//   });
  
  
  
  
  Flits(document).on('click','.js-change-quantity',function() {
    var value = $(this).parents('.product-form--atc-qty').find('input').val();
    value = parseInt(value);
    if($(this).data('func') == 'minus'){
      if(value > 1){
        value = value - 1;
      }
    }else{
      value = value + 1;
    }
    $(this).parents('.product-form--atc-qty').find('input').val(value);
  });
  
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=quick-view'
    (-1 !== url.indexOf("sort_by=") || ("page=")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits("#shopify-section-static-collection").find(".flits-wishlist-colection .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
          Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
      });
    }, 1000);
  });
  
 Flits(window).on('load',function(event) {
    setTimeout(function(){ 
      function wishListCollection() {
        if (Flits.request.page_type == 'product') {
          let collectionBtn = Flits('.flits-wishlist-colection');
          parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
            Flits(collectionBtn).show(),
            Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
        }
      }
      wishListCollection();
    }, 1000);
  });
  
  
  Flits(document).on('Flits:wishlistButton:Loaded',function(){
    setTimeout(function(){
    if(window.flitsObjects.storeData.customer_id != -1){   
      var wishlistHeaderCount = 0 ;
      var getWishlistedProductsHandle = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
      wishlistHeaderCount = getWishlistedProductsHandle.split(",").length;
      if(!getWishlistedProductsHandle == ""){
        wishlistHeaderCount = getWishlistedProductsHandle.split(",").length;
        Flits(".site-nav__link").addClass('flits-header-filled');
      }else{
        Flits(".site-nav__link").removeClass('flits-header-filled');
      }
    }
       }, 2000);
  });
  
  Flits(document).on('Flits:Wishlist:AddCount',function(event){   
    var getWishlistedProductsHandle = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
    wishlistHeaderCount = getWishlistedProductsHandle.split(",").length;
    if(wishlistHeaderCount >= 1){
       Flits(".site-nav__link").addClass('flits-header-filled');
    }
  });
  
  Flits(document).on('Flits:Wishlist:RemoveCount',function(event){    
    var getWishlistedProductsHandle = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
    wishlistHeaderCount = getWishlistedProductsHandle.split(",").length;
    if(getWishlistedProductsHandle == ''){
      Flits(".site-nav__link").removeClass('flits-header-filled');
    }
  });

  Flits(document).on('Flits:Wishlist:Removed',function(event){    
    var getWishlistedProductsHandle = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
    wishlistHeaderCount = getWishlistedProductsHandle.split(",").length;
    if(getWishlistedProductsHandle == ''){
      Flits(".site-nav__link").removeClass('flits-header-filled');
    }
  });
  
if (window.location.href.indexOf("url_to_hide_widget") > -1) {

_support['ui']['widget'] = false;

}

Flits(document).on('Flits:AccountPage:Loaded', function(event){
Flits('.flits-live-chat').click(function(){
  event.preventDefault();
  let iframe = Flits('#ShopifyChat');
  let button = iframe.contents().find('button');
  button.click();
  return false;
});
});

  
 

  
}(Flits));
